import { useState } from 'react';
import * as api from '../api/client.js';

export function AuthScreen({ onSuccess }: { onSuccess: () => void }) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (): Promise<void> => {
    setError(null);
    setLoading(true);
    try {
      if (mode === 'login') {
        await api.login({ email, password });
      } else {
        await api.register({ email, password, displayName });
      }
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'שגיאה לא ידועה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <h1>חצרות</h1>
        <p className="subtitle">משחק אסטרטגיה חסידי רב-משתתפים</p>

        <div className="tab-switcher">
          <button
            className={mode === 'login' ? 'active' : ''}
            onClick={() => setMode('login')}
          >
            כניסה
          </button>
          <button
            className={mode === 'register' ? 'active' : ''}
            onClick={() => setMode('register')}
          >
            הרשמה
          </button>
        </div>

        {mode === 'register' && (
          <label>
            <span>שם תצוגה</span>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="איך יקראו לך במשחק"
              disabled={loading}
            />
          </label>
        )}
        <label>
          <span>דוא"ל</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            disabled={loading}
          />
        </label>
        <label>
          <span>סיסמה</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={mode === 'register' ? 'לפחות 8 תווים' : ''}
            disabled={loading}
          />
        </label>

        {error && <div className="error">{error}</div>}

        <button className="primary" onClick={() => void submit()} disabled={loading}>
          {loading ? '...' : mode === 'login' ? 'כניסה' : 'הרשמה'}
        </button>
      </div>
    </div>
  );
}
